import { createEffect, createEvent, createStore } from 'effector';
import { pending } from 'patronum';
import i18n from '@shared/config/i18n';
import { createTableBag } from '@shared/tools/table';
import { DataGridColumns } from '@unicorn-shared/interface/uiKit/DataGrid/DataGrid.types';
import { incidentsRelated } from '../api';
import {
  AllreadyRelatedTicket,
  GetRelatedAvailablePayload,
  GetRelatedAvailableResponse,
  RelatedAvailableOption,
  RelatedCheckPayload,
  RelatedCheckResponse,
  RelatedSavePayload,
} from '../types';
import { fxRelatedDelete } from './table';

const { t } = i18n;

export const addRelatedAvailable = createEvent<RelatedAvailableOption[]>();
export const $relatedAvailable = createStore<RelatedAvailableOption[]>([]);

export const $relatedAvailableOptions = createStore<RelatedAvailableOption[]>([]);

export const getRelatedAvailable = createEvent<GetRelatedAvailablePayload>();

export const clearRelatedAvailable = createEvent();

export const fxGetRelatedAvailable = createEffect<
  GetRelatedAvailablePayload,
  GetRelatedAvailableResponse,
  Error
>().use(incidentsRelated.getRelatedAvailable);

export const $getRelatedAvailablePending = pending({ effects: [fxGetRelatedAvailable] });

export const startRelatedCheck = createEvent();
export const fxRelatedCheck = createEffect<
  RelatedCheckPayload,
  RelatedCheckResponse,
  Error
>().use(incidentsRelated.relatedCheck);
export const clearAllreadyRelatedTickets = createEvent();
export const $allreadyRelatedTickets = createStore<AllreadyRelatedTicket[]>([]);

export const forceRelatedSave = createEvent();
export const fxRelatedSave = createEffect<RelatedSavePayload, void, Error>().use(
  incidentsRelated.relatedSave
);
export const resetSuccessRelatedSave = createEvent();
export const $successRelatedSave = createStore(false);

export const $checkAndSavePending = pending({
  effects: [fxRelatedCheck, fxRelatedSave, fxRelatedDelete],
});

export const allreadyRelatedColumns: DataGridColumns<AllreadyRelatedTicket> = [
  {
    field: 'ticketNumber',
    headerName: `№ ${t('navMenu.dispatch.tickets')}`,
    width: 160,
    sortable: false,
    hideable: false,
  },
  {
    field: 'incidentNumber',
    headerName: `№ ${t('ofIncident')}`,
    width: 160,
    sortable: false,
    hideable: false,
  },
];

export const { $columns: $columnsParamsAllreadyRelated } = createTableBag({
  columns: allreadyRelatedColumns,
  paginationModel: {
    page: 0,
    pageSize: 10000,
  },
});

export const setIsBackConfirmDialogOpened = createEvent<boolean>();
export const $isBackConfirmDialogOpened = createStore(false);
